<template>
  <div id="step-5" class="multi-step-form active-step">
    <div class="d-flex align-content-center">
      <p>
        <img src="@/assets/arrow-left.svg" alt="OK" @click="prevEtapa()" />
      </p>
    </div>
    <div
      class="d-flex align-content-center align-flex-title"
      style="margin-top: -55px"
    >
      <p>Vamos iniciar a simulação do seu plano de saúde?</p>
    </div>
    <div class="align-flex-title">
      <h3>Preencha o seus dados</h3>
    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
    >
      <p>Email:</p>
      <b-form-input
        autocomplete="off"
        :formatter="formatter"
        v-model="email"
        placeholder="Digite aqui o seu Email"
        :class="{
          'statusok-fontbold': emailValid,
        }"
      ></b-form-input>
      <img
        v-if="emailValid"
        class="statusok-check"
        src="@/assets/statusok.svg"
        alt="OK"
      />
      <small
        >Vamos utilizar para envio de simulação caso queira realizar a
        compra.</small
      >
    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
    >
      <p>Confirmar email:</p>
      <b-form-input
        autocomplete="off"
        :formatter="formatter"
        v-model="emailConfirm"
        placeholder="Confirme aqui o seu Email"
        :class="{
          'statusok-fontbold': emailConfirmValid,
        }"
      ></b-form-input>
      <img
        v-if="emailConfirmValid"
        class="statusok-check"
        src="@/assets/statusok.svg"
        alt="OK"
      />
    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
    >
      <p>Telefone:</p>
      <b-form-input
        v-model="telefone"
        placeholder="(__) _____ - ____"
        v-mask="'(##) #####-####'"
        :class="{ 'statusok-fontbold': telefone.length > 13 }"
      ></b-form-input>
      <img
        v-if="telefone.length > 13"
        class="statusok-check"
        src="@/assets/statusok.svg"
        alt="OK"
      />
      <small>
        Vamos utilizar para envio de comunicação caso queira realizar compra.
      </small>
    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
    >
      <p>CPF:</p>
      <b-form-input
        v-model="cpf"
        placeholder="Digite aqui o seu CPF"
        v-mask="'###.###.###-##'"
        :class="{ 'statusok-fontbold': cpf.length === 14 }"
      ></b-form-input>
      <img
        v-if="cpf.length > 13"
        class="statusok-check"
        src="@/assets/statusok.svg"
        alt="OK"
      />
      <small>
        Vamos utilizar para envio de comunicação caso queira realizar compra.
      </small>
    </div>
    <!-- TESTE VALIDAÇÃO -->
    <div v-if="errors.length">
      <b v-for="erro in errors" :key="erro">{{ erro }}</b>
    </div>
    <!-- TESTE VALIDAÇÃO -->
    <div class="row consentimento-div-lgpd">
      <div
        @click="
          consentimentolgpd = true;
          setEtapa();
        "
      >
        <b-button
          class="btn-alianca btn-next btn-next btn-next-continuar-ver-planos"
          :class="{
            'btn-clicked': emailValid && telefone.length > 13,
          }"
        >
          PESQUISAR PLANOS
        </b-button>
        <b-button
          class="btn-alianca btn-next btn-icon-next"
          style="margin-left: -48px !important"
          :class="{
            'btn-clicked-icon': emailValid && telefone.length > 13,
          }"
          ><img src="@/assets/procurar-planos.svg" alt="Pesquisar planos"
        /></b-button>
      </div>
      <small style="margin-left: 15px">
        Ao continuar a simulação você concorda com a coleta de dados conforme
        nossos
        <a
          href="#"
          style="margin-left: 5px; color: #333333; text-decoration: underline"
          v-b-modal.modal-consentimento-lgpd
        >
          termos de uso
        </a>
        .
      </small>
      <small style="margin-left: 15px">
        Caso queira continuar sem a coleta de dados,
        <a
          href="#"
          style="margin-left: 5px; color: #333333; text-decoration: underline"
          @click="
            consentimentolgpd = false;
            setEtapa();
          "
        >
          continue aqui
        </a>
        .
      </small>
    </div>

    <b-modal id="modal-consentimento-lgpd">
      <template #modal-header="{ close }">
        <div style="margin: 0">
          <h5 class="title-modal">Termos de uso e política de privacidade</h5>
        </div>
        <div style="margin: 0">
          <b-button
            class="close btn-close btn-modais-nohover"
            aria-label="Close"
            @click="close()"
          >
            ×
          </b-button>
        </div>
      </template>
      <termo-lgpd />
      <template #modal-footer>
        <div
          @click="
            consentimentolgpd = true;
            setEtapa();
          "
        >
          <b-button
            class="
              btn-alianca btn-next btn-clicked btn-next-continuar-simule-lgpd
            "
            >ACEITAR OS TERMOS E CONTINUAR</b-button
          >
          <b-button class="btn-alianca btn-next btn-icon-next btn-clicked-icon"
            ><font-awesome-icon icon="angle-right" class="icon-arrow-right"
          /></b-button>
        </div>
        <div>
          <a
            class="lgpd-semconsentimento"
            href="#"
            @click="
              consentimentolgpd = false;
              setEtapa();
            "
          >
            Continuar sem aceitar termos de uso
          </a>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import store from "@/store";
import salvarLead from '@/services/salvarLead.js'

export default {
  name: "StepCinco",
  data() {
    return {
      email: "",
      emailConfirm: "",
      telefone: "",
      consentimentolgpd: false,
      errors: [],
      cpf:''
    };
  },
  computed: {
    emailValid() {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.email).toLowerCase());
    },
    emailConfirmValid() {
      return this.email === this.emailConfirm && this.emailConfirm !== "";
    },
  },
  mounted() {
    document.getElementById("step-progress").value = 6.67 * 4;
  },
  methods: {
    formatter(val) {
      return val.toUpperCase();
    },
    prevEtapa() {
      store.commit("mutAliancaProxEtapa", "step-4");
    },
    validaStep() {
      this.errors = [];

      if (!this.email) {
        this.errors.push("Preencha o email");
        return false;
      }

      if (!this.emailValid) {
        this.errors.push("Preencha o email corretamente");
        return false;
      }

      if (!this.emailConfirmValid) {
        this.errors.push("Os emails inseridos não são correspondentes");
        return false;
      }

      if (!this.telefone) {
        this.errors.push("Preencha o telefone");
        return false;
      }
      if (this.telefone.length > 0 && this.telefone.length < 14) {
        this.errors.push("Preencha o telefone corretamente");
        return false;
      }

      return true;
    },
    setEtapa() {
      if (!this.validaStep() && this.consentimentolgpd) {
        return;
      }

      if (this.consentimentolgpd) {
        const cpf = this.cpf.match(/\d/gmi).join("");
        store.commit("mutAliancaEmail", this.email);
        store.commit("mutAliancaTelefone", this.telefone);
        store.commit("mutAliancaUsrCPF", cpf);

        salvarLead(store.getters.getLeadObj)
      }

      store.commit("mutAliancaConsentimentoLGPD", this.consentimentolgpd);
      store.commit("mutAliancaProxEtapa", "end");

      document.getElementById("step-progress").value = 6.67 * 5 + 3;
      document
        .getElementById("step-progress-point2")
        .classList.add("rounded-point-progress-ok");

      this.$router.push("seu-plano");
    },
  },
};
</script>

<style>
</style>